﻿export const generalWindowBackground = '#e8e8e8';
export const paragraphText = '#656565';
